import { Database } from "./shared/Database";
const DB = Database;

function formatMessage(author: string, avatar: string, message: string) {
	return {
		author,
		avatar,
		content: message,
		time: new Date().toLocaleTimeString(),
	}
}

async function getDadJoke() {
	const name = 'Dad Joke Bot';
	const avatar = 'dad-bot';
	const request = await fetch('https://icanhazdadjoke.com/', {
		headers: {
			Accept: 'application/json'
		}
	})
	const data = await request.json();
	return formatMessage(name, avatar, data.joke);
}

async function getStoicismQuote() {
	const name = 'Stoicism Bot';
	const avatar = 'stoicism';
	const request = await fetch('https://api.stoicism.io/quotes/random', {
		headers: {
			Accept: 'application/json'
		}
	})
	const data = await request.json();
	return formatMessage(name, avatar, data.value);
}

async function getComedianJoke() {
	const name = 'Comedian Bot';
	const avatar = 'comedian-bot';
	const joke = await DB.getRandomJoke();

	return formatMessage(name, avatar, joke);
}


export default {
	getDadJoke: {
		class: getDadJoke,
		init: () => {
			return {
				name: 'Dad Joke Bot',
				avatar: 'dad-bot',
				getMessage: getDadJoke
			}
		},
	},
	getStoicismQuote: {
		class: getStoicismQuote,
		init: {
			name: 'Dad Joke'
		},
	},
	getComedianJoke: {
		class: getComedianJoke,
		init: {
			name: 'Dad Joke'
		},
	},

}
